import { defineMessages } from 'react-intl';

export const MetadataMessages = defineMessages({
  mandatoryMetadataTitle: {
    id: 'newEstimation.metadata.mandatory.title',
    defaultMessage: 'Mandatory Metadata',
  },
  mandatoryMetadataSubtitle: {
    id: 'newEstimation.metadata.mandatory.subtitle',
    defaultMessage: '{providedPercentage}% of mandatory information has been provided',
  },
  optionalMetadataTitle: {
    id: 'newEstimation.metadata.optional.title',
    defaultMessage: 'Optional Metadata',
  },
  optionalMetadataSubtitle: {
    id: 'newEstimation.metadata.optional.subtitle',
    defaultMessage: 'Do you want to provide more details on your project?',
  },
  emptyValueLabel: {
    id: 'newEstimation.metadata.emptyValueLabel',
    defaultMessage: 'Empty',
  },
  noMandatoryMetadataDefinedSubtitle: {
    id: 'newEstimation.metadata.noMandatoryMetadataDefinedSubtitle',
    defaultMessage: 'No mandatory metadata is defined',
  },
  noOptionalMetadataDefinedSubtitle: {
    id: 'newEstimation.metadata.noOptionalMetadataDefinedSubtitle',
    defaultMessage: 'No optional metadata is defined',
  },
  invalidUrl: {
    id: 'newEstimation.metadata.invalidUrl',
    defaultMessage: 'Enter a valid URL',
  },
});
